<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title></ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/login" color="light"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen class="ion-padding">
  <img src="/assets/imgs/logo-blanco.png" />
  <form (ngSubmit)="forgot()" (keyup.enter)="forgot()" [formGroup]="form">
    <ion-grid>
      <ion-row color="primary" class="ion-justify-content-center">
        <ion-col class="ion-align-self-center" size-md="6" size-lg="5" size-xs="12">
          <div *ngIf="!driver">
            <ion-item>
              <ion-label position="floating">E-mail</ion-label>
              <ion-input name="email" type="email" formControlName="email"></ion-input>
            </ion-item>
            <p
              *ngIf="form.controls['email'] && form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)"
              class="danger ion-padding"
            >
              E-mail inválido.
            </p>
          </div>
          <div *ngIf="errors">
            <p>{{errors}}</p>
          </div>
          <div>
            <ion-button
              shape="round"
              fill="outline"
              color="light"
              type="submit"
              [disabled]="form.invalid"
              expand="block"
            >
              Recuperar
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
